<template>
  <div class="login-container">
    <img class="logo" src="@/assets/logo-transparent.png" alt="" />
    <div class="bg-wrapper box-center">
      <div class="wrapper-text">
        <div class="wrapper-title">{{ $t('Hi!') }}</div>
        <div class="wrapper-title">{{ $t('欢迎使用') }} <span class="text-main">iTEX</span> {{ $t('工业云') }}</div>
        <div class="wrapper-sub">{{ $t('纺织行业数字化整体解决方案服务平台') }}</div>
      </div>
      <!-- <div class="customer-service">{{ $t('联系客服') }}</div> -->
    </div>

    <!-- 国际化切换 -->
    <ku-dropdown
      v-if="supportLang"
      class-name="lang-switch"
      dropdown-type="button"
      button-type="text"
      operate-menu
      display-menu
      pre-icon="ku ku-icon-yuyanqiehuan"
      :suf-icon="`lang-arrow ku ${showLangDropdown ? 'ku-icon-mianxingjiantou-shang' : 'ku-icon-mianxingjiantou-xia'}`"
      :button-text="langList.filter(l => l.value === lang)[0].label"
      :menu-list="langList"
      @visible-change="(v) => showLangDropdown = v"
      @command="(label) => onChangeLang(langList.filter(l => l.label === label)[0].value)"
    />

    <div class="login-wrapper box-center">
      <div class="login-form-wrapper">
        <div class="login-text">
          <h2 class="user-login">{{ $t('用户登录') }}</h2>
          <el-alert
            v-if="login.errorShow"
            :title="login.errorInfo"
            :type="login.errorType"
            show-icon
            style="width: 298px; margin: 5px auto;"
            :closable="false"
          />
          <div v-else style="margin: 48px auto;"></div>
        </div>
        <el-form
          ref="loginForm"
          :model="loginForm"
          :rules="rules"
          autocomplete="off"
          class="login-form"
          label-position="left"
        >

          <!-- <el-form-item prop="tenant" v-show="isMultiTenant">
              <el-input
                :placeholder="$t('企业')"
                @keyup.enter.native="handleLogin"
                autocomplete="off"
                name="tenantView"
                prefix-icon="el-icon-user"
                ref="tenant"
                type="text"
                v-model="loginForm.tenantView"
              />
            </el-form-item> -->
          <!-- 账号 -->
          <el-form-item prop="account">
            <el-input
              ref="account"
              v-model="loginForm.account"
              :placeholder="$t('手机号')"
              autocomplete="off"
              clearable
              name="account"
              type="text"
              @keyup.enter.native="handleLogin"
            >
              <i slot="prefix" class="el-input__icon iconfont icon-mobile"></i>
            </el-input>
          </el-form-item>
          <!-- 密码 -->
          <el-form-item v-show="login.isShowPwd" prop="password">
            <el-input
              ref="password"
              v-model="loginForm.password"
              :placeholder="$t('密码')"
              :show-password="true"
              autocomplete="off"
              clearable
              name="password"
              type="password"
              @keyup.enter.native="handleLogin"
            >
              <i slot="prefix" class="el-input__icon iconfont icon-lock"></i>
            </el-input>
          </el-form-item>
          <!-- 短信验证码 -->
          <div v-show="isSmsCode" class="msg-code-input" prop="code">
            <el-input
              ref="smsCode"
              v-model="loginForm.smsCode"
              :placeholder="$t('短信验证码')"
              autocomplete="off"
              max="6"
              name="smsCode"
              prefix-icon="el-icon-lock"
              style="width: 70%;margin-right: 8px;"
              type="text"
              @keyup.enter.native="handleLogin"
            />
            <el-button
              class="msg-btn"
              type="defalut"
              style="margin-right: 0;"
              :disabled="!isGetCode"
              @click="sendSmsLoginCode"
            >{{ smsLoginText }}</el-button>
          </div>
          <!-- 图片验证码 -->
          <el-form-item v-show="isCaptcha" class="code-input" prop="code">
            <el-input
              ref="code"
              v-model="loginForm.code"
              :placeholder="$t('验证码')"
              autocomplete="off"
              name="code"
              prefix-icon="el-icon-lock"
              style="width: 50%"
              type="text"
              @keyup.enter.native="handleLogin"
            />
            <img v-show="isCaptcha" :src="imageCode" alt="codeImage" class="code-image" @click="getCodeImage" />
          </el-form-item>
          <!-- 自动登录/忘记密码 -->
          <div class="auto-login">
            <el-checkbox v-model="login.isAutoLogin" @change="autoLogin">{{ $t('记住密码') }}</el-checkbox>
            <span v-if="isShowForget" class="font text-main forget-pwd pointer" @click="openForgetPwdModal">{{ $t('忘记密码') }}</span>
          </div>
          <!-- 登录 -->
          <el-button
            :loading="loading"
            class="login-btn shadow"
            type="primary"
            @click.native.prevent="handleLogin"
          >
            {{ $t('登 录') }}
          </el-button>
        </el-form>
        <div class="tip-text">
          <a href="https://www.keyenlinx.com/" target="_blank">Copyright © <span>{{ today }}</span> {{ $t('keyenlinx技研智联') }}</a>
        </div>
      </div>
    </div>
    <!-- 忘记密码 -->
    <el-dialog
      :title="$t('忘记密码')"
      :visible.sync="login.forgetPwdModal"
      width="576px"
      :close-on-click-modal="false"
      @close="closeForgetPwdModal"
    >
      <el-form ref="forgetForm" :model="forgetForm" :rules="rules">
        <el-form-item :label="$t('账号：')" :label-width="login.formLabelWidth">
          <div class="d-flex">
            <el-select v-model="forgetForm.areaCode" placeholder="+86" style="width: 100px; margin-right: 10px;">
              <el-option label="+86" value="86" />
            </el-select>
            <el-input v-model="forgetForm.account" autocomplete="off" />
          </div>
        </el-form-item>
        <el-form-item :label="$t('短信验证码：')" :label-width="login.formLabelWidth" prop="smsCode">
          <div class="d-flex">
            <el-input
              v-model="forgetForm.smsCode"
              max="6"
              type="text"
              autocomplete="off"
              style="margin-right: 10px;"
            />
            <el-button
              class="msg-btn"
              type="defalut"
              style="margin-right: 0;"
              :disabled="!isGetCode"
              @click="sendSmsForgetCode"
            >{{ smsForgetText }}</el-button>
          </div>
        </el-form-item>
        <el-form-item :label="$t('新密码：')" :label-width="login.formLabelWidth" prop="newPwd">
          <el-input v-model="forgetForm.newPwd" type="password" autocomplete="off" style="width: 100%;" />
        </el-form-item>
        <el-form-item :label="$t('确认密码：')" :label-width="login.formLabelWidth" prop="newPassword">
          <el-input v-model="forgetForm.newPassword" type="password" autocomplete="off" style="width: 100%;" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="login.forgetPwdModal = false">{{ $t('取 消') }}</el-button>
        <el-button type="primary" @click="handleForget">{{ $t('确 定') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import db from '@klinx/utils/localstorage';
import {
  randomNum
} from '@klinx/utils';
import { baseAuthorityApi, baseTenantApi, baseApplicationApi } from '@klinx/base/src/api/index.js';
import dayjs from 'dayjs';
import { encryptAES, decryptAES } from '@klinx/utils/commons';
import { LANGUAGE_LIST } from '@klinx/utils/lang-map';

let interval = null;
// 是否包含一位特殊字符
const regCharacter = /(?=.*[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、])/;
export default {
  name: 'Login',
  data() {
    return {
      supportLang: true, // 全放开
      lang: db.get('LANGUAGE', 'zh'),
      showLangDropdown: false,
      langList: LANGUAGE_LIST,
      isShowForget: false,
      today: dayjs().year(),
      // 是否启用多租户
      isMultiTenant: process.env.VUE_APP_IS_MULTI_TENANT_TYPE !== 'NONE',
      // 短信验证码
      isSmsCode: false,
      isGetCode: true,
      smsLoginText: this.$t('获取验证码'),
      smsForgetText: this.$t('获取验证码'),
      currentTime: 60,
      // 图片验证码
      isCaptcha: false,
      tabActiveName: 'bindLogin',
      login: {
        // 是否自动登录
        isAutoLogin: false,
        // 是否显示密码输入框
        isShowPwd: true,
        // 错误提示
        errorShow: false,
        errorType: 'info',
        errorInfo: this.$t('第一次登录，请输入短信验证码'),
        // 忘记密码
        forgetPwdModal: false,
        formLabelWidth: '120px'
      },
      logo: [{
        img: 'gitee.png',
        name: 'gitee',
        radius: true
      },
      {
        img: 'github.png',
        name: 'github',
        radius: true
      },
      {
        img: 'tencent_cloud.png',
        name: 'tencent_cloud',
        radius: true
      },
      {
        img: 'qq.png',
        name: 'qq',
        radius: false
      },
      {
        img: 'dingtalk.png',
        name: 'dingtalk',
        radius: true
      },
      {
        img: 'microsoft.png',
        name: 'microsoft',
        radius: false
      }
      ],
      loginForm: {
        account: '',
        code: '',
        grantType: 'password',
        key: randomNum(24, 16),
        password: '',
        refreshToken: '',
        smsCode: '',
        tenant: ''
        // grantType: process.env.VUE_APP_IS_CAPTCHA === "true" ? "captcha" : "password",
      },
      forgetForm: {
        areaCode: '',
        account: '',
        newPwd: '',
        newPassword: '',
        smsCode: ''
      },
      rules: {
        account: [{
          required: true,
          message: this.$t('请您输入手机号'),
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: this.$t('请您输入密码'),
          trigger: 'blur'
        }],
        smsCode: [{
          required: true,
          message: this.$t('不能为空'),
          trigger: 'blur'
        }],
        newPassword: [{
          required: true,
          message: this.$t('不能为空'),
          trigger: 'blur'
        }],
        newPwd: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error(this.$t('新密码不能为空！请重新输入')));
            } else {
              if (value.length > 16) {
                callback(new Error(this.$t('密码长度不超过16个字符')));
              } else if (value.length < 6) {
                callback(new Error(this.$t('密码长度不低于6个字符')));
              } else {
                if (regCharacter.test(value)) {
                  callback(new Error(this.$t('密码为6-16位的密码，包含数字或字母，不支持特殊符号')));
                } else {
                  callback();
                }
              }
            }
          },
          trigger: 'blur'
        }]
        // code: {
        //   required: true,
        //   message: this.$t('不能为空'),
        //   trigger: "blur"
        // },
      },
      authUser: null,
      loading: false,
      showDialog: false,
      redirect: undefined,
      otherQuery: {},
      imageCode: '',
      page: {
        width: window.screen.width * 0.5,
        height: window.screen.height * 0.5
      }
    };
  },
  mounted() {
    db.clear();
    // this.getCodeImage();
    this.showForgetPwd();
    this.getCookie();
  },
  destroyed() {
    window.removeEventListener('message', this.resolveSocialLogin);
  },
  methods: {
    /**
     * 切换国际化处理
     */
    onChangeLang(lang) {
      // 国际化切换标记
      this.lang = lang;
      db.save('LANGUAGE', lang);
      this.$i18n.locale = lang;
      this.$router.go(0);
    },
    showForgetPwd() {
      baseAuthorityApi.showForgetPwd().then(res => {
        this.isShowForget = res.data.data;
      });
    },
    // 获取短信验证码
    sendSmsLoginCode() {
      baseAuthorityApi.getSmsLoginCode({
        account: this.loginForm.account
      }).then(res => {
        if (res.data.isSuccess) {
          this.$message.success(this.$t('验证码已经发送至您的手机，请查收。'));
        } else {
          this.$message.error(res.data.msg);
        }
      });
      this.isGetCode = false;
      interval = setInterval(() => {
        this.currentTime--;
        this.smsLoginText = this.currentTime + this.$t('秒');
        if (this.currentTime <= 0) {
          clearInterval(interval);
          this.isGetCode = true;
          this.smsLoginText = this.$t('重新发送');
          this.currentTime = 60;
        }
      }, 1000);
    },
    // 获取忘记密码短信验证码
    sendSmsForgetCode() {
      baseAuthorityApi.getSmsForgetCode({
        account: this.forgetForm.account
      }).then(res => {
        if (res.data.isSuccess) {
          this.$message.success(this.$t('验证码已经发送至您的手机，请查收。'));
          this.isGetCode = false;
          interval = setInterval(() => {
            this.currentTime--;
            this.smsForgetText = this.currentTime + this.$t('秒');
            if (this.currentTime <= 0) {
              clearInterval(interval);
              this.isGetCode = true;
              this.smsForgetText = this.$t('重新发送');
              this.currentTime = 60;
            }
          }, 1000);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 获取验证码图片
    getCodeImage() {
      baseAuthorityApi
        .getCaptcha(this.loginForm.key)
        .then(response => {
          const res = response.data;
          if (res.byteLength <= 100) {
            this.$message({
              message: this.$t('系统维护中，请稍后再试~'),
              type: 'error'
            });
          }
          return (
            'data:image/png;base64,' +
              btoa(
                new Uint8Array(res).reduce(
                  (data, byte) => data + String.fromCharCode(byte),
                  ''
                )
              )
          );
        })
        .then(res => {
          this.imageCode = res;
        })
        .catch(e => {
          if (e.toString().indexOf('429') !== -1) {
            this.$message({
              message: this.$t('获取验证码过于频繁，请1分钟后再试'),
              type: 'error'
            });
          } else {
            this.$message({
              message: this.$t('获取图形验证码失败'),
              type: 'error'
            });
          }
        });
    },
    // 登录
    handleLogin() {
      // this.loginForm.tenant = `${Base64.encode(this.loginForm.tenantView)}`;
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loginSubmit();
        } else {
          return false;
        }
      });
    },
    loginSubmit() {
      this.loading = true;
      this.$store.commit('account/setTenant', this.loginForm.tenant);
      let res = {};
      baseAuthorityApi
        .login(this.loginForm, {
          tenant: this.loginForm.tenant,
          'X-isTenant': false
        })
        .then(response => {
          res = response.data;
          // 非首次登录，需校验密码，密码错误校验图片验证码
          if (res.code === 41001) {
            this.isCaptcha = true;
            this.loginForm.grantType = 'captcha';
            this.getCodeImage();
            this.$confirm(res.msg, this.$t('登录失败'), {
              confirmButtonText: this.$t('知道了'),
              showCancelButton: false,
              showClose: false,
              type: 'error'
            });
            return;
          }
          // 首次登录，不需校验密码，直接走短信验证流程
          if (res.code === 41002) {
            this.login.isShowPwd = false;
            this.login.errorShow = true;
            this.login.errorType = 'info';
            this.login.errorInfo = this.$t('第一次登录，请输入短信验证码');
            this.isSmsCode = true;
            return;
          }
          // 错误达5次，锁定账号
          if (res.code === 41005) {
            this.$confirm(this.$t('密码错误次数已达上限，请稍后再试或重置密码'), this.$t('账号锁定5分钟'), {
              confirmButtonText: this.$t('知道了'),
              showCancelButton: false,
              showClose: false,
              type: 'error'
            });
            return;
          }
          // 账号密码错误
          if (res.code === -10) {
            this.login.errorShow = true;
            this.login.errorType = 'error';
            this.login.errorInfo = res.msg;
            return;
          }
          // 账号过期，跳转到停用页
          if (res.code === 97) {
            this.$router.push('/ban');
            return;
          }
          if (res.code !== 0) {
            this.$confirm(res.msg, this.$t('登录失败'), {
              confirmButtonText: this.$t('知道了'),
              showCancelButton: false,
              showClose: false,
              type: 'error'
            });
            return;
          }
          baseApplicationApi.getMyAppCurTenant().then(res => {
            console.log(this.$t('获取当前租户所有可用应用'), res);
          });
          baseAuthorityApi.getRouter({
            appCode: 'IMES'
          }).then(res => {
            console.log(this.$t('查询用户可用的路由'), res);
          });
          // 获取当前账号下的所有租户
          baseTenantApi.listTenantsAll().then(resp => {
            const res = resp.data.data.filter(item => {
              if (item.code !== '0000' || item.code !== '100000') return item;
            });
            this.$store.commit('account/setTenantsList', res);
          });
          this.login.errorShow = false;
          if (res.isSuccess) {
            this.saveLoginData(
              res.data[this.$t('token')],
              res.data['refreshToken'],
              res.data['expiration'],
              res.data['tenant']
            );
            if (this.login.isAutoLogin) {
              this.setCookie(encryptAES(this.loginForm.account), encryptAES(this.loginForm.password), 7);
            } else {
              this.clearCookie();
            }
            this.saveUserInfo(res.data);
            this.getResource();
          } else {
            this.$confirm(res.msg, this.$t('提示'), {
              confirmButtonText: this.$t('知道了'),
              showCancelButton: false,
              showClose: false,
              type: 'error'
            });
          }
        })
        .finally(() => {
          !res.isSuccess && res.code !== 41001 && this.isCaptcha && this.getCodeImage();
          this.loading = false;
        });
    },
    // 自动登录
    autoLogin(e) {
      e ? (this.login.isAutoLogin = true) : (this.login.isAutoLogin = false);
    },
    // 设置cookie
    setCookie(username, password, exdays) {
      // 获取当前登录的时间
      const exdate = new Date();
      // 将当前登录的时间加上七天，就是cookie过期的时间，也就是保存的天数
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays);
      // 字符串拼接cookie,因为cookie存储的形式是name=value的形式
      window.document.cookie = 'userName' + '=' + username + ';path=/;expires=' + exdate.toGMTString();
      window.document.cookie = 'userPwd' + '=' + password + ';path=/;expires=' + exdate.toGMTString();
      window.document.cookie = 'isAutoLogin' + '=' + this.login.isAutoLogin + ';path=/;expires=' + exdate
        .toGMTString();
    },
    // 获取cookie中的用户名和密码
    getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          // // 判断查找相对应的值
          if (arr2[0] === 'userName') {
            this.loginForm.account = decryptAES(arr2[1]);
          } else if (arr2[0] === 'userPwd') {
            this.loginForm.password = decryptAES(arr2[1]);
          } else if (arr2[0] === 'isAutoLogin') {
            this.login.isAutoLogin = Boolean(arr2[1]);
          }
        }
      }
    },
    // 清除cookie
    clearCookie() {
      this.setCookie('', '', -1); // 清空并设置天数为负1天
    },
    // 忘记密码
    openForgetPwdModal() {
      clearInterval(interval);
      this.login.forgetPwdModal = true;
      this.smsLoginText = this.$t('获取验证码');
      this.currentTime = 60;
      this.isGetCode = true;
      this.forgetForm.account = '';
      this.forgetForm.newPwd = '';
      this.forgetForm.newPassword = '';
      this.forgetForm.smsCode = '';
    },
    closeForgetPwdModal() {
      clearInterval(interval);
      this.smsForgetText = this.$t('获取验证码');
      this.currentTime = 60;
      this.isGetCode = true;
    },
    // 确认忘记密码
    handleForget() {
      this.$refs.forgetForm.validate(valid => {
        if (valid) {
          const form = JSON.parse(JSON.stringify(this.forgetForm));
          if (form.newPassword !== form.newPwd) {
            this.$message.error(this.$t('两次输入的密码不一致'));
            return;
          }
          baseAuthorityApi.resetPwd({
            account: this.forgetForm.account,
            newPassword: this.forgetForm.newPassword,
            smsCode: this.forgetForm.smsCode
          }).then(res => {
            if (res.data.isSuccess) {
              this.$message.success(res.data.msg);
              this.login.forgetPwdModal = false;
              this.$router.reload();
            } else {
              this.$message.error(res.data.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 保存登录状态
    saveLoginData(token, refreshToken, expiration, tenant) {
      this.$store.commit('account/setToken', token);
      this.$store.commit('account/setRefreshToken', refreshToken);
      this.$store.commit('account/setExpireTime', expiration);
      this.$store.commit('account/setTenant', tenant);
    },
    // 保存用户
    saveUserInfo(user) {
      this.$store.commit('account/setUser', {
        id: user.userId,
        account: user.account,
        name: user.name,
        avatar: user.avatar,
        workDescribe: user.workDescribe
      });
    },
    // 获取用户可用的所有资源
    getResource() {
      baseAuthorityApi.getResource().then(response => {
        const res = response.data;
        if (res.isSuccess) {
          const authorityResource = res.data;
          const permissionsList = authorityResource.resourceList || [];

          this.$store.commit('account/setPermissions', permissionsList);
          this.$store.commit('account/setAuthorityResource', authorityResource);

          this.loginSuccess();
        } else {
          this.getCodeImage();
        }
      });
    },
    loginSuccess() {
      // todo: 暂时都跳回门户首页
      const redirectUrl = '/home' || decodeURIComponent(this.$route.query.redirectUrl);
      this.$message({
        message: this.$t('登录成功'),
        type: 'success'
      });

      if (!redirectUrl) {
        this.$router.push('/home');
        return;
      }

      if (redirectUrl.includes('http')) {
        window.location.replace(redirectUrl);
        return;
      }

      // 判断路径所属一级菜单再重定向
      this.$router.replace({
        path: redirectUrl,
        query: {
          checkParent: 1
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-input__inner {
  &:hover {
    border: 1px solid $vice-hover !important;
  }
  &:focus {
    border: 1px solid $vice !important;
    box-shadow: 0 0 0 2px $vice-text-disabled;
  }
}

.login-container {
  display: flex;
  width: 100%;
  height:100%;
  background: url('../../assets/login-bg.jpg') no-repeat;
  background-size: cover;
  background-position: center 0;
  position: relative;

  .logo{
    width: 200px;
    height: 50px;
    position: absolute;
    top: 48px;
    left: 48px;
  }

  .bg-wrapper {
    width: 60%;
    height: 100vh;

    .wrapper-title {
      font-size: 44px;
      margin-bottom: 8px;
      font-weight: 600;
    }

    .wrapper-sub {
      margin-top: 50px;
      color: #202224;
      font-size: 24px;
    }

    .customer-service {
      font-size: 12px;
      opacity: .8;
      cursor: pointer;
    }
  }

  .lang-switch {
    position: absolute;
    top: 75px;
    right: 70px;
    margin: 0;
    ::v-deep {
      .ku-dropdown--button {
        margin: 0;
        padding: 0;
        background: transparent !important;
      }
      .el-dropdown-menu {
        width: fit-content !important;
        min-width: 140px !important;
        left: 0 !important;
        .popper__arrow {
          display: block !important;
        }
      }
    }
  }

  .login-wrapper {
    width: 40%;
    .login-form-wrapper{
      width: 400px;
      height: 476px;
      padding: 30px 40px;
      background: rgba(255, 255, 255, 0.85);
      backdrop-filter: blur(100px);
      border-radius: 8px;
      .login-text{
        .user-login{
          text-align: left;
          font-size: 32px;
          font-weight: 600;
        }
      }
      .tip-text{
        font-size: 12px;
        line-height: 20px;
        color: rgba(0, 0, 0, 0.45);
        text-align: left;
        margin-top: 48px;
      }
    }
  }

  .login-info {
    position: absolute;
    left: 15%;
    top: 44%;
    margin-top: -100px;
    color: #fff;

    .title {
      font-size: 1.8rem;
      font-weight: 600;
    }

    .sub-title {
      font-size: 1.5rem;
      margin: 0.3rem 0 0.7rem 1rem;
    }

    .desc {
      font-size: 0.96rem;
      line-height: 1.9rem;
    }
  }

  .login-form {
    border-radius: 3px;

    ::v-deep {
      .el-input__inner, .el-input__icon{
        height: 40px;
        line-height: 40px;
      }

      .el-icon-circle-close::before {
        z-index: 10;
      }
    }

    .iconfont{
      font-size: 22px;
    }

    .msg-code-input {
      display: flex;
      justify-content: space-between;
      margin-bottom: 15px;

      .el-button:hover,
      .el-button:focus {
        color: #FF6900;
        background-color: #FFFFFF;
        border-color: #FF8929;
      }
    }

    .auto-login {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 32px;

      .forget-pwd{
        &:hover{
          color: #FF6900;
          border-bottom: 1px solid #FF6900;
        }
        &:active{
          color: #8C2C00;
          border-bottom: 1px solid #8C2C00;
        }
      }

      .el-button:hover,
      .el-button:focus {
        color: #FFA552;
        background-color: #FFFFFF;
      }
    }

    .login-btn {
      width: 100%;
      height: 48px;
      font-size: 20px;
      border: none;
      border-radius: 4px !important;
      background: linear-gradient(270deg, #FF7F0D 22.58%, #FF580D 100%);
      transition: all .3s;
      &:hover{
        transition: all .3s;
        filter: brightness(120%);
      }
      &:active{
        transition: all .3s;
        filter: brightness(90%);
      }
    }

    .code-input {
      text-align: left;
    }

    .code-image {
      display: inline-block;
      vertical-align: top;
      cursor: pointer;
      height: 40px;
      width: 115px;
      margin-left: 20px;
    }

    .login-type {
      text-align: right;
      display: inline-block;
      width: 100%;
    }

    .logo-wrapper {
      display: inline-block;
      margin: 10px 0;

      img {
        width: 1.9rem;
        display: inline-block;
        margin: 0.8rem 0.8rem -0.8rem 0.8rem;
        cursor: pointer;

        &.radius {
          border-radius: 50%;
        }
      }
    }

  }

  .login-footer {
    position: fixed;
    bottom: 1rem;
    width: 100%;
    text-align: center;
    color: white;
    font-size: 0.85rem;
    line-height: 1rem;
    height: 1rem;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .title-container {
    position: relative;

    .title {
      font-size: 20px;
      color: rgba(0, 0, 0, 0.85);
      margin: 0 auto 40px auto;
      text-align: center;
      font-weight: bold;
    }

    .set-language {
      color: #aaa;
      position: absolute;
      top: 3px;
      font-size: 18px;
      right: 0;
      cursor: pointer;
    }
  }

  .thirdparty-button {
    position: absolute;
    right: 0;
    bottom: 6px;
  }

  @media only screen and (max-width: 470px) {
    .thirdparty-button {
      display: none;
    }
  }

  @media screen and (max-width: 1100px) {
    .login-info {
      left: 8%;
    }
  }

  @media screen and (max-width: 970px) {
    .login-form {
      left: 50%;
    }

    .login-info {
      display: none;
    }
  }
}

::v-deep {
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #FF6900;
    border-color: #FF6900;
  }
  .el-checkbox__inner:hover {
    border-color: $vice !important;
  }

  .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #000000;
  }

  .el-checkbox.is-bordered.is-checked {
    border-color: #FF6900;
  }

  .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #FF6900;
  }
}
</style>
